import React, { useEffect, useState } from 'react';

import {
  SafeAreaView,
  View,
  Text,
  StyleSheet,
  Dimensions,
  TextInput,
  Image,
  Pressable,
  Platform,
} from 'react-native';
import { MaterialCommunityIcons, MaterialIcons } from '@expo/vector-icons';
import { IconButton } from 'react-native-paper';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import type { RootStackParamList } from '../navigation/stackTypes';
import { UserSessionAttributes } from '../models/user-session-model';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';
import { notificationService } from '../services/notification-service';
import { updateUser } from '../store/actions/user-actions';
import PayoutRulesSelect from '../components/PayoutRulesSelect';
import { UserAttributes } from '../models/login-register-model';
import { PayoutRules_t } from '../models/payout-rules-model';
import { savePayoutRules } from '../services/payout-service';
import { isSuccessful } from '../services/api-requests';
import Header from '../components/Header';

const { width, height } = Dimensions.get('window');

type Props = NativeStackScreenProps<RootStackParamList, 'PayoutRules'>;

const PayoutRules: React.FC<Props> = ({ navigation, route }) => {
  const [payoutDate, setPayoutDate] = useState<number>(0); //day of the month
  const [payoutDay, setPayoutDay] = useState<number>(1); //day of the week
  const [payoutCadence, setPayoutCadence] = useState<'monthly' | 'weekly'>(
    'monthly'
  );
  const [isPayoutCadenceOpen, setPayoutCadenceOpen] = useState(false);
  const [isPayoutDayOpen, setPayoutDayOpen] = useState(false);
  const dispatch: AppDispatch = useDispatch();

  const session: UserSessionAttributes | undefined = useSelector(
    (state: RootState) => state.user.session
  );
  const user: UserAttributes = useSelector(
    (state: RootState) => state.user.userObj
  );

  const handleSave = async (e: React.TouchEvent | any) => {
    //console.log(e.nativeEvent.target.value);
    console.log(
      `Date: ${payoutDate}\nDay: ${payoutDay}\nCadence: ${payoutCadence}\nCadence?: ${isPayoutCadenceOpen}\nDay?:${isPayoutDayOpen}`
    );
    const rules: PayoutRules_t = {
      payout_cadence: payoutCadence,
      payout_date: payoutCadence === 'monthly' ? payoutDate : payoutDay,
    };
    const resp = await savePayoutRules(rules);
    console.log(resp);
    if (isSuccessful(resp.status)) {
      notificationService.sendNotification(
        'success',
        'Your settings have been saved!'
      );
    } else {
      notificationService.sendNotification(
        'error',
        `There was an error setting your rules ${resp.payload?.message}`
      );
    }
  };

  useEffect(() => {
    //check existing payout data
    if (user.payoutRules && user.payoutRules !== null) {
      setPayoutCadence(user.payoutRules.payout_cadence);
      if (user.payoutRules.payout_cadence === 'monthly') {
        setPayoutDate(user.payoutRules.payout_date);
      } else {
        setPayoutDay(user.payoutRules.payout_date);
      }
    }
  }, []);

  return (
    <SafeAreaView style={styles.safeArea}>
      {Platform.OS !== 'web' && (
        <Header headerText="Set Payout Rules" hasLeftIcon={true} />
      )}
      <View style={[styles.containerBgColor, { height: height - 65 }]}>
        <View style={styles.contentContainer}>
          <View className="flex items-center mt-6">
            <Image
              source={require('../../assets/meanderlogowhite_120x120.png')}
              style={{ width: 100, height: 100, alignItems: 'center' }}
            />
          </View>
          <PayoutRulesSelect
            isLoadingOnboard={false}
            handleSave={handleSave}
            setPayoutCadence={setPayoutCadence}
            setPayoutDate={setPayoutDate}
            setPayoutDay={setPayoutDay}
            payoutCadence={payoutCadence}
            payoutDate={payoutDate}
            payoutDay={payoutDay}
            isPayoutCadenceOpen={isPayoutCadenceOpen}
            setPayoutCadenceOpen={setPayoutCadenceOpen}
            isPayoutDayOpen={isPayoutDayOpen}
            setPayoutDayOpen={setPayoutDayOpen}
          />
        </View>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#1A1D21',
  },
  containerBgColor: {
    flex: 1,
    backgroundColor: '#1A1D21',
    paddingBottom: 60,
  },
  contentContainer: {
    flex: 1,
    padding: 16,
  },
  BgColor1: {
    backgroundColor: '#292D33',
  },
  BgColorDisabled: {
    backgroundColor: '#3A3B3C', // Dark gray background for disabled look
    color: '#B0B0B0', // Lighter gray text color
    opacity: 0.5, // Faded effect
  },
  buttonContainer: {
    position: 'absolute',
    bottom: 20,
    left: 16,
    right: 16,
  },
  button: {
    backgroundColor: '#39BEB7',
    padding: 16,
    borderRadius: 9999,
    alignItems: 'center',
  },
  mainHead: {
    color: 'white',
    fontSize: 18,
    alignSelf: 'center',
    fontWeight: '400',
  },
});

export default PayoutRules;
